import { createApi } from '@reduxjs/toolkit/query/react'
import type { AuthzMe } from '@atbash-labs/proxy-client'

import { PROXY_API_V1_URL, ontologyBaseQuery } from '../core'

export const authzApi = createApi({
  reducerPath: 'authzApi',
  baseQuery: ontologyBaseQuery,
  endpoints: (builder) => ({
    getAuthzMe: builder.query<AuthzMe, void>({
      query: () => `${PROXY_API_V1_URL}/authz/me`
    })
  })
})

export const { useGetAuthzMeQuery } = authzApi
